import { SSN_ERROR_CODES, SSN_ERROR_DUPLICATE_ACCOUNT } from 'stash/actions/ssn';

const ssn = (state = {}, action) => {
	switch (action.type) {
		case SSN_ERROR_CODES: {
			return {
				...state,
				ssnErrorCodes: action.errors,
			};
		}
		case SSN_ERROR_DUPLICATE_ACCOUNT: {
			return {
				...state,
				duplicateAccount: {
					originalAccountMaskedEmail: action.message,
				},
			};
		}
		default:
			return state;
	}
};

export default ssn;
